import defaultsDeep from 'lodash.defaultsdeep';
import React from 'react';
import { ThemeProvider } from 'styled-components';
import defaultTheme from '../../theme';
export { withTheme, ThemeContext } from 'styled-components';
export const UIConfigurator = _ref => {
  let {
    theme,
    children
  } = _ref;
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: theme ? defaultsDeep(theme, defaultTheme) : defaultTheme
  }, children);
};
export default UIConfigurator;
//# sourceMappingURL=UIConfigurator.js.map